(function() {
    'use strict';

    angular
        .module('atheer.topic', [

        ]);
})();
